import { render, staticRenderFns } from "./PadMessagePopup.vue?vue&type=template&id=3338650f&"
import script from "./PadMessagePopup.vue?vue&type=script&lang=js&"
export * from "./PadMessagePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports